import { IActivityBase } from '../../models/activities';
import { ISpotBase } from '../../models/spots';
import wbsBookingsApi from '../apis/wbsBookingsApi';

interface IUpdateSpotAvatarProps {
  spotId: string;
  avatarData: FormData;
}

export interface IUpdatedSpotAvatar extends ISpotBase {
  activities: IActivityBase[];
}

export const updateSpotAvatarsService = async ({
  avatarData,
  spotId,
}: IUpdateSpotAvatarProps): Promise<IUpdatedSpotAvatar> => {
  const { data } = await wbsBookingsApi.patch<IUpdatedSpotAvatar>(
    `/avatars/spots/${spotId}`,
    avatarData,
  );

  return data;
};
